/**
 * The placeholder cover, shown wherever a track has no art of its own: the
 * player bar, the cover tiles, and the artwork published to the OS media
 * controls. One constant so a rename cannot silently split them.
 */
export const UNKNOWN_ALBUM_ART_PATH = '/unknown-album.png';
